import './assets';
import '../styles/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

// eslint-disable-next-line no-console
console.log('App is running on the browser too!');
